import {handleGetDropdownList} from '@/services/dropdown'
import { DROPDOWN_TYPES } from '@/utils/constants/dropdownConstants'
import {useQueryClient} from '@tanstack/react-query'
import {useCallback, useEffect, useState} from 'react'

export const useDropdown = ({dropdownType}) => {
  const [dropdownList, setDropdownList] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const queryClient = useQueryClient()

  const formatData = useCallback(response => {
    if (response?.data?.length <= 0) return

    const formatedData = response?.data?.map((item, index) => {
      if( dropdownType === DROPDOWN_TYPES.PointMultiplierCategory) {
        return {
          id: item?.categoryId,
          displayText: item?.category,
          isBadge: false,
          value: item?.category, // value is not present in the pepsico-ds-dropdown component
        }
      }
      return {
        id: index,
        displayText: item.displayText,
        isBadge: false,
        value: item.value, // value is not present in the pepsico-ds-dropdown component
      }
    })
    return formatedData
  }, [dropdownType])

  const fetchDropdownData = useCallback(
    async queryKey => {
      const cachedData = queryClient.getQueryData(queryKey)
      if (cachedData) {
        setDropdownList(cachedData)
        setIsLoading(false)
        return
      }
      try {
        setIsLoading(true)
        const response = await handleGetDropdownList(queryKey)
        const formattedData = response ? formatData(response, queryKey) : []
        setDropdownList(formattedData)
        queryClient.setQueryData(queryKey, formattedData)
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setIsLoading(false)
      }
    },
    [queryClient, formatData]
  )

  useEffect(() => {
    fetchDropdownData(dropdownType)
  }, [dropdownType, fetchDropdownData])

  return {
    dropdownList,
    isLoading,
  }
}
